import { ComponentProps, FC } from 'react'
import { stencil } from 'react-common'
import { TenantLogoPluginComponent } from './TenantLogoPluginComponent'

const { LogoSlotPlugin } = stencil

export const TenantLogoPlugin: FC<ComponentProps<typeof TenantLogoPluginComponent>> = ({ mode = 'logged', link }) => {
  return (
    <LogoSlotPlugin>
      <TenantLogoPluginComponent mode={mode} link={link} />
    </LogoSlotPlugin>
  )
}
